import { TableRating } from '@shared/types/floorPlans';

export const RATING_OPTIONS = [
  { label: 'Economy', value: TableRating.Economy, iconName: 'square' as const },
  { label: 'Standard', value: TableRating.Standard, iconName: 'fire' as const },
  {
    label: 'Standard+',
    value: TableRating.StandardPlus,
    iconName: 'fire' as const,
  },
  { label: 'Premium', value: TableRating.Premium, iconName: 'fire' as const },
  {
    label: 'Premium+',
    value: TableRating.PremiumPlus,
    iconName: 'fire' as const,
  },
  { label: 'Elite', value: TableRating.Elite, iconName: 'star' as const },
] as const;

export type TableRatingDisplay =
  | { type: 'square' }
  | { type: 'fire'; count: number }
  | { type: 'star' };

const fireCountMap: Record<TableRating, number> = {
  [TableRating.Economy]: 0,
  [TableRating.Standard]: 1,
  [TableRating.StandardPlus]: 2,
  [TableRating.Premium]: 3,
  [TableRating.PremiumPlus]: 4,
  [TableRating.Elite]: 0,
};

export const getTableRatingDisplay = (
  rating: TableRating,
): TableRatingDisplay => {
  if (rating === TableRating.Economy) return { type: 'square' };
  if (rating === TableRating.Elite) return { type: 'star' };
  return { type: 'fire', count: fireCountMap[rating] };
};

export const getRatingLabel = (rating: TableRating): string => {
  return TableRating[rating].replace('Plus', '+');
};
